require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-selection-sort-algorithm.json") })
        }
      }, "path---blog-selection-sort-algorithm");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-selection-sort-algorithm!./.cache/json/blog-selection-sort-algorithm.json
// module id = 1063
// module chunks = 231608221292675